import { InputTypes } from "@/constants/enums";
import type { IFormField } from "@/types/app";
import PasswordField from "./password-field";
import UsernameField from "./username-field";
import SelectField from "./select-field";
import PhoneField from "./phone-field";
import type { Control, FieldErrors } from "react-hook-form";
import Checkbox from "./checkbox";
import ImageField from "./image-field";
import FileUploadField from "./file-upload-field";
import TextField from "./text-field";
import TextareaField from "./textarea-field";
import MultiSelectField from "./multi-select-field";
import RatingField from "./rating-field";

interface Props extends IFormField {
  errors: FieldErrors;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>;
  accept?: string;
  maxSize?: number;
  allowedTypes?: string[];
  fileType?: "image" | "video" | "pdf" | "zip" | "any";
  onImageChange?: (file: File | null) => void;
}

const FormFields = (props: Props) => {
  const { type } = props;

  const renderField = (): React.ReactNode => {
    if (type === InputTypes.PASSWORD) {
      return <PasswordField {...props} />;
    }

    if (props.name === "username" && props.showGenerateButton) {
      return <UsernameField {...props} />;
    }

    if (type === InputTypes.CHECKBOX) {
      return <Checkbox {...props} />;
    }

    if (type === InputTypes.SELECT) {
      return <SelectField {...props} />;
    }

    if (type === InputTypes.PHONE) {
      return <PhoneField {...props} />;
    }

    if (type === InputTypes.IMAGE) {
      return <ImageField {...props} />;
    }

    if (type === InputTypes.TEXTAREA) {
      return <TextareaField {...props} />;
    }

    if (type === InputTypes.MULTI_SELECT) {
      return <MultiSelectField {...props} />;
    }

    if (type === "file") {
      return <FileUploadField {...props} />;
    }

    if (type === InputTypes.RATING) {
      return <RatingField {...props} />;
    }

    return <TextField {...props} />;
  };

  return <>{renderField()}</>;
};

export default FormFields;
